import { Component, OnInit } from '@angular/core';
import {ModalController, PopoverController} from '@ionic/angular';
import {IonModalPage} from '../ion-modal/ion-modal.page';
import { AlertmodalPage } from '../alertmodal/alertmodal.page';
import { HistoryPage } from '../history/history.page';

@Component({
  selector: 'app-popovercomponent',
  templateUrl: './popovercomponent.page.html',
  styleUrls: ['./popovercomponent.page.scss'],
})
export class PopovercomponentPage implements OnInit {
  public data:any;
  public price:any;
  constructor( public popoverController: PopoverController,public modalController: ModalController) { }

    myFormat = function(val) {

        if (val<999){
            return val;
        }else {
            return val.format();
        }

    }
  ngOnInit() {
  }

    async presentAlert(price:any) {
        this.popoverController.dismiss();
        const modal = await this.modalController.create({
            component: AlertmodalPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                'price': this.price,
                'data': this.data,
            }
        });
        return await modal.present();
    }
    async historyModal(price:any) {
        this.popoverController.dismiss();
        const modal = await this.modalController.create({
            component: HistoryPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                'price': this.price,
            }
        });
        return await modal.present();
    }
    async presentModal(price:any) {
        this.popoverController.dismiss();
        const modal = await this.modalController.create({
            component: IonModalPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                'price': this.price,
            }
        });
        return await modal.present();
    }

}
